import React from 'react';

export default function FontIcon({ name }: { name: string }) {
  return <i aria-hidden="true" className={`iconfont iconfont-${name}`} />;
}
